import baseService from '../shared/baseService';

const spotlightService = () => baseService('spotlights');

export default { 
    spotlightService
};

